"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchySearchReducer = exports.HierarchySearchActionCreator = exports.HierarchySearchActionTypes = void 0;
var axios_1 = __importDefault(require("axios"));
var types_1 = require("../types");
var HierarchySearchActionTypes;
(function (HierarchySearchActionTypes) {
    HierarchySearchActionTypes["SEARCH_RESULTS_RESET"] = "SEARCH_RESULTS_RESET";
    HierarchySearchActionTypes["SEARCH_RESULTS_BEGIN"] = "SEARCH_RESULTS_BEGIN";
    HierarchySearchActionTypes["SEARCH_RESULTS_END"] = "SEARCH_RESULTS_END";
    HierarchySearchActionTypes["SEARCH_RESULTS_FAILED"] = "SEARCH_RESULTS_FAILED";
    HierarchySearchActionTypes["RESET_SEARCH_RESULTS"] = "RESET_SEARCH_RESULTS";
})(HierarchySearchActionTypes = exports.HierarchySearchActionTypes || (exports.HierarchySearchActionTypes = {}));
var HierarchySearchActionCreator = /** @class */ (function () {
    function HierarchySearchActionCreator(hierarchyNodeActionCreator, hierarchyBaseUrl, hierarchyStateGetter) {
        var _this = this;
        this.getSearchResults = function (searchText) {
            return function (dispatch, getState) {
                var _a, _b, _c;
                if (searchText.trim().length < 2) {
                    return;
                }
                var hierarchyVm = _this.hierarchyStateGetter(getState());
                var hierarchyMetadataId = getHierarchyMetadataId(hierarchyVm);
                var skip = 0;
                var excludeFromSearch;
                var shouldExcludeDescendants = false;
                if ((_a = hierarchyVm.hierarchyEditState) === null || _a === void 0 ? void 0 : _a.selectedNodeId) {
                    var selectedNodeId = hierarchyVm.hierarchyEditState.selectedNodeId;
                    excludeFromSearch = selectedNodeId;
                    var nodeMoveState = hierarchyVm.hierarchyEditState.nodeMoveState;
                    // If the node being moved does not also displace its children, then ensure its descendants can be searched
                    if (nodeMoveState !== types_1.NodeMoveState.MoveKeepOpen && ((_b = hierarchyVm.nodes) === null || _b === void 0 ? void 0 : _b[selectedNodeId].nodeType) !== types_1.NodeType.Location) {
                        shouldExcludeDescendants = true;
                    }
                }
                if ((_c = hierarchyVm.hierarchySearchState) === null || _c === void 0 ? void 0 : _c.searchResults) {
                    if (searchText !== hierarchyVm.hierarchySearchState.searchText) {
                        dispatch({ type: HierarchySearchActionTypes.SEARCH_RESULTS_RESET });
                    }
                    else {
                        skip = hierarchyVm.hierarchySearchState.searchResults.length;
                    }
                }
                dispatch({ type: HierarchySearchActionTypes.SEARCH_RESULTS_BEGIN, searchText: searchText });
                var searchParams = {
                    SearchText: searchText,
                    Skip: skip,
                    ExcludeNodeId: excludeFromSearch,
                    ExcludeDescendants: shouldExcludeDescendants,
                };
                return axios_1.default
                    .get(_this.hierarchyBaseUrl + hierarchyMetadataId + '/search?searchParam=' + encodeURIComponent(JSON.stringify(searchParams)))
                    .then(processResponse)
                    .then(function (body) {
                    return dispatch({ type: HierarchySearchActionTypes.SEARCH_RESULTS_END, searchResults: body, searchText: searchText });
                })
                    .catch(function (ex) {
                    return dispatch({ type: HierarchySearchActionTypes.SEARCH_RESULTS_FAILED, message: ex.message });
                });
            };
        };
        this.selectSearchResult = function (resultId) {
            return _this.hierarchyNodeActionCreator.fetchNode(resultId, true);
        };
        this.resetSearchResults = function () {
            return function (dispatch) {
                dispatch({ type: HierarchySearchActionTypes.RESET_SEARCH_RESULTS });
            };
        };
        this.hierarchyNodeActionCreator = hierarchyNodeActionCreator;
        this.hierarchyBaseUrl = hierarchyBaseUrl;
        var defaultGetter = function (applicationState) { return applicationState.Hierarchy; };
        this.hierarchyStateGetter = hierarchyStateGetter || defaultGetter;
    }
    return HierarchySearchActionCreator;
}());
exports.HierarchySearchActionCreator = HierarchySearchActionCreator;
var getHierarchyMetadataId = function (hierarchyVm) {
    return hierarchyVm.hierarchyHeader.hierarchyMetadataId;
};
var processResponse = function (response) {
    if (response.status === 200) {
        return response.data;
    }
    throw Error('Invalid response status - ' + response.status);
};
var HierarchySearchReducer = function (state, incomingAction) {
    if (!state) {
        return {};
    }
    switch (incomingAction.type) {
        case HierarchySearchActionTypes.SEARCH_RESULTS_BEGIN: {
            var updatedState = __assign(__assign({}, state), { hierarchySearchState: __assign(__assign({}, state.hierarchySearchState), { searchText: incomingAction.searchText, loading: true }) });
            return updatedState;
        }
        case HierarchySearchActionTypes.SEARCH_RESULTS_RESET: {
            var updatedState = __assign(__assign({}, state), { hierarchySearchState: __assign(__assign({}, state.hierarchySearchState), { searchResults: [] }) });
            return updatedState;
        }
        case HierarchySearchActionTypes.SEARCH_RESULTS_END: {
            var searchResults = incomingAction.searchResults, searchText = incomingAction.searchText;
            var updatedSearchResults = [];
            if (state.hierarchySearchState && state.hierarchySearchState.searchResults) {
                updatedSearchResults = __spreadArray(__spreadArray([], state.hierarchySearchState.searchResults, true), searchResults, true);
            }
            else {
                updatedSearchResults = __spreadArray([], searchResults, true);
            }
            var updatedState = __assign(__assign({}, state), { hierarchySearchState: {
                    searchText: searchText,
                    searchResults: updatedSearchResults,
                    loading: false,
                    hasMoreResults: searchResults && searchResults.length === 100,
                } });
            return updatedState;
        }
        case HierarchySearchActionTypes.RESET_SEARCH_RESULTS: {
            return __assign(__assign({}, state), { hierarchySearchState: undefined });
        }
        default:
            return state;
    }
};
exports.HierarchySearchReducer = HierarchySearchReducer;
